export default __webpack_public_path__ + "bae9d79af8f5afaa09c08d99a15de707.png";